import React from 'react';

function Skills() {
    const skillCategories = [
        {
            title: "Programming Languages",
            items: [
                {
                    id: 1,
                    title: 'Python',
                    style: 'from-sky-600 to-sky-400',
                    shadow: 'bg-sky-600',
                    level: 'Advanced',
                    years: '5+ years'
                },
                {
                    id: 2,
                    title: 'Javascript',
                    style: 'from-yellow-500 to-yellow-300',
                    shadow: 'bg-yellow-500',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 3,
                    title: 'Java',
                    style: 'from-orange-600 to-orange-400',
                    shadow: 'bg-orange-600',
                    level: 'Intermediate',
                    years: '3+ years'
                },
                {
                    id: 4,
                    title: 'TypeScript',
                    style: 'from-blue-600 to-blue-400',
                    shadow: 'bg-blue-600',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 5,
                    title: 'C++',
                    style: 'from-indigo-600 to-indigo-400',
                    shadow: 'bg-indigo-600',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 6,
                    title: 'SQL',
                    style: 'from-teal-600 to-teal-400',
                    shadow: 'bg-teal-600',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 7,
                    title: 'Go',
                    style: 'from-cyan-600 to-cyan-400',
                    shadow: 'bg-cyan-600',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 8,
                    title: 'C',
                    style: 'from-gray-600 to-gray-400',
                    shadow: 'bg-gray-600',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 9,
                    title: 'HTML/CSS',
                    style: 'from-pink-600 to-pink-400',
                    shadow: 'bg-pink-600',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 10,
                    title: 'C#',
                    style: 'from-purple-600 to-purple-400',
                    shadow: 'bg-purple-600',
                    level: 'Intermediate',
                    years: '1+ years'
                }
            ]
        },
        {
            title: "Cloud & DevOps",
            items: [
                {
                    id: 1,
                    title: 'AWS',
                    style: 'from-orange-600 to-orange-400',
                    shadow: 'bg-orange-600',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 2,
                    title: 'GCP',
                    style: 'from-red-600 to-red-400',
                    shadow: 'bg-red-600',
                    level: 'Intermediate',
                    years: '2+ years'
                },
                {
                    id: 3,
                    title: 'Docker',
                    style: 'from-blue-600 to-blue-400',
                    shadow: 'bg-blue-600',
                    level: 'Advanced',
                    years: '2+ years'
                },
                {
                    id: 4,
                    title: 'Kubernetes',
                    style: 'from-blue-700 to-blue-500',
                    shadow: 'bg-blue-700',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 5,
                    title: 'Terraform',
                    style: 'from-purple-600 to-purple-400',
                    shadow: 'bg-purple-600',
                    level: 'Beginner',
                    years: '< 1 year'
                },
                {
                    id: 6,
                    title: 'Git & VSCode',
                    style: 'from-gray-700 to-gray-500',
                    shadow: 'bg-gray-700',
                    level: 'Advanced',
                    years: '5+ years'
                },
                {
                    id: 7,
                    title: 'Ansible',
                    style: 'from-red-700 to-red-500',
                    shadow: 'bg-red-700',
                    level: 'Intermediate',
                    years: '1+ years'
                }
            ]
        },
        {
            title: "Frameworks & Libraries",
            items: [
                {
                    id: 1,
                    title: 'React.js',
                    style: 'from-cyan-600 to-cyan-400',
                    shadow: 'bg-cyan-600',
                    level: 'Advanced',
                    years: '3+ years'
                },
                {
                    id: 2,
                    title: 'Next.js',
                    style: 'from-gray-900 to-gray-700',
                    shadow: 'bg-gray-900',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 3,
                    title: 'Flask',
                    style: 'from-teal-600 to-teal-400',
                    shadow: 'bg-teal-600',
                    level: 'Advanced',
                    years: '1+ years'
                },
                {
                    id: 4,
                    title: 'Node.js',
                    style: 'from-green-600 to-green-400',
                    shadow: 'bg-green-600',
                    level: 'Advanced',
                    years: '2+ years'
                },
                {
                    id: 5,
                    title: 'Langchain',
                    style: 'from-amber-600 to-amber-400',
                    shadow: 'bg-amber-600',
                    level: 'Intermediate',
                    years: '1+ years'
                },
                {
                    id: 6,
                    title: 'TailwindCSS',
                    style: 'from-teal-500 to-teal-300',
                    shadow: 'bg-teal-500',
                    level: 'Advanced',
                    years: '2+ years'
                },
                {
                    id: 7,
                    title: 'FastAPI',
                    style: 'from-blue-600 to-blue-400',
                    shadow: 'bg-blue-600',
                    level: 'Advanced',
                    years: '2+ years'
                },
            ]
        }
    ];

    return (
        <div className='min-h-screen w-full bg-gradient-to-b from-zinc-400 to-slate-300 py-24'>
            <div className='max-w-6xl mx-auto px-4 sm:px-6'>
                <h2 className='text-4xl md:text-6xl font-bold text-black text-center mb-16'>
                    Skills & Expertise
                </h2>

                <div className='space-y-20'>
                    {skillCategories.map((category, index) => (
                        <div key={index} className='space-y-8'>
                            <h3 className='text-3xl md:text-4xl font-bold text-gray-800 text-center'>
                                {category.title}
                            </h3>
                            
                            <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
                                {category.items.map((skill) => (
                                    <div
                                        key={skill.id}
                                        className='group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-none transition-all duration-300 transform hover:-translate-y-1'
                                    >
                                        {/* Shadow overlay */}
                                        <div className={`absolute inset-0 opacity-10 ${skill.shadow}`}></div>
                                        
                                        {/* Hover gradient */}
                                        <div className={`absolute inset-0 bg-gradient-to-br ${skill.style} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
                                        
                                        <div className='relative p-6 flex flex-col items-center text-center z-10'>
                                            <h4 className='text-xl font-semibold text-gray-900 group-hover:text-white transition-colors duration-300'>
                                                {skill.title}
                                            </h4>
                                            <div className='mt-2 space-y-1'>
                                                <p className='text-sm text-gray-600 group-hover:text-gray-100 transition-colors duration-300'>
                                                    {skill.level}
                                                </p>
                                                <p className='text-sm text-gray-500 group-hover:text-gray-200 transition-colors duration-300'>
                                                    {skill.years}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Skills;